import { Content, Entity, UiAction } from '../../types';

export type QuickLookOptions = {
  titleField: string;
  preTitleField?: string;
  contents: Content[];
};

export type SelectionAction = {
  label: string;
  minSelection?: number;
  maxSelection?: number;
  forcedSelection?: number;
  action: UiAction;
};

export type SelectionConfig = {
  selectionActions: SelectionAction[];
  outOfRangeMsg?: string;
};

export type TableCustomiseOption = {
  label: string;
  paramName: string;
  options: Entity[];
  isMultiSelect?: boolean;
  selectionLimit?: number; // used with multiSelect
  isUpsellFeatureOrKpisIndicator?: boolean; // indicates if this option is an upsell option
};

export type TableCustomiseOptions = {
  columnsParam?: string;
  options?: TableCustomiseOption[];
};

export enum LeaderboardType {
  Product = 'product',
  Brand = 'brand',
  Region = 'region',
  SegmentFeature = 'segment feature',
  ProductFeature = 'product feature',
  Country = 'country',
  ProductGroup = 'product group',
}

export type ProductGroup = {
  id: string;
  name: string;
  modelIds: string[];
  selected: boolean;
  groupType: GroupType;
};
export enum GroupType {
  selectGroups = 'Select groups',
  otherGroups = 'Other groups',
}
